import React from "react";
import { Form, Button } from "react-bootstrap";
import { NomuraLogo } from "./NomuraLogo";
import { _t } from "../../app/i18n/i18n";

export const LoginSupport = () => (
  <section className="w-100 screen-height text-white bg-dark p-5 ">
    <Form className="maxw-600">
      <NomuraLogo />
      <NeedSupport />
      {/* <AskAQuestion /> */}
      <ProblemsLoggingIn />
      <Button variant="outline-light" className="w-100 more-border-radius my-3" onClick={() => window.history.back()}>
        {_t("Back")}
      </Button>
    </Form>
  </section>
);

const NeedSupport = () => (
  <Form.Group>
    <Form.Label className="font-weight-lighter h5 mb-3 d-block">{_t("Need Support?")}</Form.Label>
    <Form.Text>{_t("For assistance, please contact your sales representatives or the portal support team:")}</Form.Text>
    <Button variant="outline-light" className="w-100 more-border-radius my-3">
      <a href="mailto:grpsupport@nomura.com" alt="support" className="text-light d-block">
        {_t("GRP Support")} ✉
      </a>
    </Button>
    <hr />
  </Form.Group>
);

// eslint-disable-next-line no-unused-vars
// const AskAQuestion = () => (
//   <Form.Group>
//     <Form.Label className="font-weight-lighter h5 mb-3 d-block">{_t("Ask a Question")}</Form.Label>
//     <Form.Text className="text-left">{_t("Type your support question")}</Form.Text>
//     <Form.Control type="text" placeholder="Please type your question" className="more-border-radius" />
//     <Button variant="outline-light" className="w-100 more-border-radius my-3">
//       {/* TODO: Backend 'send a question' implementation */}
//       {_t("Send")}
//     </Button>
//     <hr />
//   </Form.Group>
// );

const ProblemsLoggingIn = () => (
  <Form.Group>
    <Form.Label className="font-weight-lighter h5 mb-3 d-block">{_t("Problems logging in?")}</Form.Label>
    <Form.Text className="text-justify">
      <p>{_t("GRP uses cookies msg")}</p>
      <p>{_t("Try deleting cookies msg")}</p>
      <p>{_t("This app runs in msg")}</p>
    </Form.Text>
    <hr />
  </Form.Group>
);
